import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { InternalTransferSubmit, RegularISubmit, SubmitResponse } from '@interfaces';
import { FraudOutcome } from '@interfaces/fraud-detector/fraud-detector.interface';
import { RecaptchaMockResult } from '@interfaces/submit/submit.service.interface';
import { IOpenAccount } from '@shared/models';
import { Observable } from 'rxjs';

import { LoggerService } from '../../modules/logger/logger';
import { FMFResponse } from '../fraud-micro-frontend/fmf.service';

@Injectable({
  providedIn: 'root',
})
export class SubmitService {
  constructor(
    private http: HttpClient,
    private loggerService: LoggerService,
  ) {}

  submitEndpoint(
    submitData: RegularISubmit,
    fmfResponse: FMFResponse,
    mockRecaptchaLevel: RecaptchaMockResult,
  ): Observable<any> {
    return this.http.post(`secure/submit`, {
      ...submitData,
      fmfResponse,
      mockRecaptchaLevel,
    });
  }

  submitMultiTransactionsEndpoint(
    submitData: RegularISubmit | InternalTransferSubmit,
    fmfResponse: FMFResponse,
    oaFMFResponse: FMFResponse | null,
    mockRecaptchaLevel: RecaptchaMockResult,
    oaData: IOpenAccount,
    mockFraudDetectorLevel: FraudOutcome | null,
  ): Observable<any> {
    return this.http.post(`secure/submit-multi-transactions`, {
      ...submitData,
      fmfResponse,
      oaFMFResponse,
      mockRecaptchaLevel,
      oaData,
      mockFraudDetectorLevel,
    });
  }

  internalTransferSubmitEndpoint(
    submitData: InternalTransferSubmit,
    fmfResponse: FMFResponse,
    mockRecaptchaLevel: RecaptchaMockResult,
  ): Observable<SubmitResponse> {
    return this.http.post<SubmitResponse>(`secure/submit/internal-transfer`, {
      ...submitData,
      fmfResponse,
      mockRecaptchaLevel,
    });
  }
}
